import {
  faInfoCircle, faShip, faBoxes, faFileContract,
  faUsers, faUniversity, faTruck, faPercentage,
  faFlask, faCommentDots
} from '@fortawesome/free-solid-svg-icons';

const WIDGET_DEFINITIONS = [
  {
    id: 'status_dates',
    label: 'Status & Dates',
    icon: faInfoCircle,
    fields: [
      { key: 'status', label: 'Status' },
      { key: 'charter_party_date', label: 'Charter Party Date', type: 'date' },
      { key: 'bill_of_lading_date', label: 'BL Date', type: 'date' },
      { key: 'delivery_laycan', label: 'Laycan' },
      { key: 'delivery_estimated_time_of_arrival', label: 'ETA', type: 'date' },
      { key: 'reporting_month', label: 'Reporting Month' },
    ],
  },
  {
    id: 'vessel',
    label: 'Vessel',
    icon: faShip,
    fields: [
      { key: 'vessel_name', label: 'Vessel Name' },
      { key: 'vessel_imo_number', label: 'IMO' },
      { key: 'vessel_mmsi_number', label: 'MMSI' },
      { key: 'vessel_navigation_status', label: 'Nav Status' },
      { key: 'vessel_speed', label: 'Speed (kn)' },
      { key: 'vessel_owners', label: 'Owners' },
      { key: 'vessel_brokers', label: 'Brokers' },
    ],
  },
  {
    id: 'product_quantity',
    label: 'Product & Quantity',
    icon: faBoxes,
    fields: [
      { key: 'delivery_product_quantity', label: 'Quantity' },
      { key: 'delivery_product_unit', label: 'Unit' },
      { key: 'bill_of_lading_quantity', label: 'BL Weight' },
      { key: 'product_origin', label: 'Origin' },
      { key: 'delivery_destination', label: 'Destination' },
      { key: 'industry', label: 'Industry' },
    ],
  },
  {
    id: 'contract',
    label: 'Contract',
    icon: faFileContract,
    fields: [
      { key: 'delivery_unique_number', label: 'Delivery No.' },
      { key: 'purchase_contract_quality_basis', label: 'Purchase Quality Basis' },
      { key: 'sales_contract_quality_basis', label: 'Sales Quality Basis' },
      { key: 'purchase_confirmation_date', label: 'Purchase Conf. Date', type: 'date' },
      { key: 'sale_confirmation_date', label: 'Sale Conf. Date', type: 'date' },
      { key: 'seller_contract_number', label: 'Seller Contract No.' },
      { key: 'buyer_contract_number', label: 'Buyer Contract No.' },
    ],
  },
  {
    id: 'parties',
    label: 'Parties',
    icon: faUsers,
    fields: [
      { key: 'delivery_producer', label: 'Producer' },
      { key: 'seller_crm_profile_name', label: 'Seller' },
      { key: 'buyer_crm_profile_name', label: 'Buyer' },
      { key: 'delivery_end_user', label: 'End User' },
      // hms_entity holds an HMSEntity id ("2"); the serializer resolves it.
      { key: 'hms_entity_name', label: 'IMT Entity' },
    ],
  },
  {
    id: 'banking',
    label: 'Banking',
    icon: faUniversity,
    fields: [
      { key: 'seller_crm_data.primary_bank.bank_name', label: "Seller's Bank", nested: true },
      { key: 'buyer_crm_data.primary_bank.bank_name', label: "Buyer's Bank", nested: true },
      { key: 'hms_crm_data.primary_bank.bank_name', label: 'IMT Bank', nested: true },
    ],
  },
  {
    id: 'freight',
    label: 'Freight',
    icon: faTruck,
    fields: [
      { key: 'loading_port_location', label: 'Loading Port' },
      { key: 'discharging_port_location', label: 'Discharge Port' },
      { key: 'incoterms_purchase', label: 'Incoterms Purchase' },
      { key: 'incoterms_sale', label: 'Incoterms Sale' },
      { key: 'freight_per_ton', label: 'Freight Cost' },
      { key: 'freight_per_ton_currency', label: 'Freight Currency' },
    ],
  },
  {
    id: 'commissions',
    label: 'Commissions',
    icon: faPercentage,
    fields: [
      { key: 'address_commission', label: 'Address Commission' },
      { key: 'mercurius_commission', label: 'Mercurius Commission' },
      { key: 'brokerage_commission', label: 'Brokerage Commission' },
    ],
  },
  {
    id: 'quality_coa',
    label: 'Quality / COA',
    icon: faFlask,
    fields: [
      { key: 'loading_port_actual_quality_net_calorific_value_NAR', label: 'NAR (Load)' },
      { key: 'loading_port_actual_quality_gross_calorific_value_GAR', label: 'GAR (Load)' },
      { key: 'loading_port_actual_quality_total_moisture_ARB', label: 'Moisture (Load)' },
      { key: 'loading_port_actual_quality_ash_content', label: 'Ash (Load)' },
      { key: 'loading_port_actual_quality_volatile_matter', label: 'Volatile (Load)' },
      { key: 'loading_port_actual_quality_total_sulphur', label: 'Sulphur (Load)' },
      { key: 'loading_port_actual_quality_hard_grove_index_HGI', label: 'HGI (Load)' },
    ],
  },
  {
    id: 'comments',
    label: 'Comments',
    icon: faCommentDots,
    fields: [
      { key: 'additional_notes', label: 'Notes' },
    ],
  },
];

export const DEFAULT_WIDGET_ORDER = WIDGET_DEFINITIONS.map((w, i) => ({
  id: w.id,
  visible: true,
  order: i,
}));

export const getNestedValue = (obj, path) => {
  if (!obj || !path) return null;
  return path.split('.').reduce((acc, part) => acc?.[part], obj);
};

export default WIDGET_DEFINITIONS;
